// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/rotate-cw.js';

import { paths } from '../generated/rotate-cw';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('rotate-cw', Original, paths);
